import React from "react";
import { AnimatePresence } from "framer-motion";
import Router from "./RouterComponent";

function AnimatedRoutesComponent() {
  return (
    <AnimatePresence>
      <Router />
    </AnimatePresence>
  );
}

export default AnimatedRoutesComponent;
